import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LabelTypeEnum } from '@app/shared/enums/common.enums';

@Component({
    selector: 'app-print-confirmation-dialog',
    templateUrl: './print-confirmation-dialog.component.html',
    standalone: false
})
export class PrintConfirmationDialogComponent{
  LABEL_TYPE = LabelTypeEnum;

  constructor(
    private dialogRef: MatDialogRef<PrintConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string, showZplOption: boolean, showPdfOption: boolean },
  ) {
  }

  onConfirm(labelType: LabelTypeEnum) {
    this.dialogRef.close(labelType);
  }
}